export default __webpack_public_path__ + "static/media/boy4.110c7293.jpg";